<template>
  <div class="order-detail">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('nav.remotePay')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('nav.orderManage')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('orderManage.detail')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="panel down">
      <div class="panel-header">
        <div class="details">
          <span class="panel-header__desc">{{$t('orderManage.detail')}}</span>
          <div type="primary" class="panel-header-btn btn1" @click="show = true" v-if="deliveryStatus === 1 && tranStatus === 2 && delivery_info.delivery_type === $t('remote.form.logisticsMode.option2')">{{ $t('orderManage.delevery') }}</div>
          <div type="primary" class="panel-header-btn btn2" v-if="tranStatus === 1" @click="openEdit">{{ $t('orderEdit.edit') }}</div>
        </div>
      </div>

      <div class="panel-body">
        <div class="mcht-information">
          <div class="mcht">
            <p>{{ $t('orderDetail.mchtOrderId') }}</p>
            <p>{{ mcntOrderId }}</p>
          </div>
          <div class="mcht">
            <p>{{ $t('orderDetail.payOrderId') }}</p>
            <p>{{ payOrderId }}</p>
          </div>
          <div class="mcht">
            <p>{{ $t('orderDetail.linkId') }}</p>
            <p>{{ linkId }}</p>
          </div>
          <div class="mcht">
            <p>{{ $t('orderDetail.transactionStatus') }}</p>
            <p>{{ tranStatusLang }}</p>
          </div>
          <div class="mcht">
            <p>{{ $t('orderDetail.paymentlink') }}</p>
            <p>{{ payLink }}</p>
          </div>
          <div class="mcht">
            <p>{{ $t('orderDetail.createTime') }}</p>
            <p>{{ stime }}</p>
          </div>
          <div class="mcht expected-date">
            <p>{{ $t('orderDetail.expectedDeliveryTime') }}</p>
            <p>{{ delivery_info.delivery_time }}</p>
          </div>
        </div>
        <div class="product-information">
          <p class="product-title">{{ $t('orderDetail.productTitle') }}</p>
          <el-table
          :data="goods_info"
          style="width: 100%">
            <el-table-column label="Goods Name" prop="goods_name"></el-table-column>
            <el-table-column label="Quantity" prop="quantity"></el-table-column>
            <el-table-column label="Currency" prop="currency">
              <template slot-scope="scope">
                {{currencyList[scope.row.currency]}}
              </template>
            </el-table-column>
            <el-table-column label="Unit Price" prop="unit_price"></el-table-column>
            <el-table-column label="Total Price" prop="total_currency">
              <template slot-scope="scope">
                {{currencyList[scope.row.currency]}} {{scope.row.total_currency}}
              </template>
            </el-table-column>
          </el-table>
          <div class="total-price product">
            <p>{{ $t('orderDetail.totalAmount') }}</p>
            <p>{{ totalNum }}</p>
          </div>
          <div class="delivery-status product">
            <p>{{ $t('orderDetail.deliveryStatus') }}</p>
            <p v-if="delivery_info.delivery_type === $t('remote.form.logisticsMode.option2')">{{ deliveryStatusList[deliveryStatus] }}</p>
            <p v-else>{{ $t('orderManage.filter.noDelivery') }}</p>
          </div>
        </div>
        <div class="buyer-information">
          <p class="buyer-title">{{ $t('orderDetail.buyerTitle')}}</p>
          <div class="buyer">
            <p>{{ $t('orderDetail.customerName') }}</p>
            <p>{{ customer_info.name }}</p>
          </div>
          <div class="buyer">
            <p>{{ $t('orderDetail.customerPhone') }}</p>
            <p>{{ customer_info.mobile }}</p>
          </div>
          <div class="buyer">
            <p>{{ $t('orderDetail.customerEmail') }}</p>
            <p>{{ customer_info.email }}</p>
          </div>
          <div class="buyer">
            <p>{{ $t('orderDetail.customerAdress') }}</p>
            <p>{{ customer_info.address }}</p>
          </div>
        </div>
        <div class="express-information">
          <p class="express-title">{{ $t('orderDetail.expressTitle') }}</p>
          <div class="express">
            <p>{{ $t('orderDetail.logisticsMode') }}</p>
            <p>{{ delivery_info.delivery_type }}</p>
          </div>
          <div class="express">
            <p>{{ $t('orderDetail.expectedDeliveryTime') }}</p>
            <p>{{ delivery_info.delivery_time }}</p>
          </div>
          <div class="express" v-if="deliveryStatus === 2">
            <p>{{ $t('orderDetail.expressCompany') }}</p>
            <p>{{ delivery_info.express_name }}</p>
          </div>

          <div class="express" v-if="deliveryStatus === 2">
            <p>{{ $t('orderDetail.expressNumber') }}</p>
            <p>{{ delivery_info.express_no }}</p>
          </div>
        </div>
        <div class="remaks">
          <p class="remaks-title">{{ $t('orderDetail.description') }}</p>
          <p class="remark-content">{{ desc }}</p>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="show"
      size="tiny"
      class="fe_dialog">
      <div slot="title" class="dialogTitle">
        <p>{{ $t('orderManage.confirmDelivery') }}</p>
      </div>
      <div class="dialogContent">
        <p>{{ $t('orderManage.deliveryMsg' )}}</p>
        <el-form ref="expressForm" :model="expressForm" label-width="154px" label-position="left" :rules="expressFormRules">
          <el-form-item :label="$t('orderDetail.expressCompany')" prop="express_name">
            <el-input v-model="expressForm.express_name" :maxlength="50"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orderDetail.expressNumber')" prop="express_no">
            <el-input v-model="expressForm.express_no" :maxlength="50"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDelivery">{{ $t('orderManage.cancel') }}</el-button>
        <el-button type="primary" :disabled="deliveryBtnStatus" @click="delivery">{{ $t('orderManage.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible"
      size="tiny"
      class="edit-information">
      <div slot="title" class="dialogTitle">
        <p>{{ $t('orderEdit.title') }}</p>
      </div>
      <div class="dialogContent">
        <el-form ref="editForm" :model="editForm" label-position="left" label-width="174px" :rules="editFormRules">
          <el-table :data="editForm.goods_info"  class="tableDatas">
            <el-table-column :label="$t('remote.form.productName')" prop="goods_name">
              <template slot-scope="scope">
                <!-- <el-form-item :prop="'goods_info' + scope.$index + '.goods_name'" :rules="editFormRules.goods_name"> -->
                  <el-input v-model="scope.row.goods_name" disabled></el-input>
                <!-- </el-form-item> -->
              </template>
            </el-table-column>
            <el-table-column :label="$t('remote.form.quantity')" prop="quantity">
              <template slot-scope="scope">
                <!-- <el-form-item :prop="'goods_info' + scope.$index + '.quantity'" :rules="editFormRules.quantity"> -->
                  <el-input v-model="scope.row.quantity" disabled></el-input>
                <!-- </el-form-item> -->
              </template>
            </el-table-column>
            <el-table-column :label="$t('remote.form.currency')" prop="currency">
              <template slot-scope="scope">
                <el-select v-model="scope.row.currency" disabled>
                  <el-option
                    v-for="item in currentList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('remote.form.price')" prop="unit_price">
              <template slot-scope="scope">
                <!-- <el-form-item :prop="'goods_info' + scope.$index + '.unit_price'" :rules="editFormRules.unit_price"> -->
                  <el-input v-model="scope.row.unit_price" disabled></el-input>
                <!-- </el-form-item> -->
              </template>
            </el-table-column>
            <el-table-column :label="$t('remote.form.totalAmount')" prop="total_currency">
              <template slot-scope="scope">
                <!-- <el-form-item :prop="'goods_info' + scope.$index + '.total_currency'" :rules="editFormRules.total_currency"> -->
                  <el-input v-model="scope.row.total_currency" disabled></el-input>
                <!-- </el-form-item> -->
              </template>
            </el-table-column>
          </el-table>
          <!-- 总价 -->
          <el-form-item :label="$t('remote.form.totalAmount')" class="close-icon">
            <el-select v-model.trim="editForm.totalCurrency" class="total-amount" disabled>
              <el-option v-for="item in currentList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <el-form-item prop="totalAmount" class="sing-validte">
              <el-input v-model.trim="editForm.totalAmount" class="inputtotal-amount" disabled></el-input>
            </el-form-item>
          </el-form-item>
          <!-- 支付截止日期 -->
          <el-form-item :label="$t('remote.form.paymentDeadline')" class="fe_payment-date">
            <el-date-picker
              v-model.trim="editForm.paymentDeadline"
              type="date"
              :editable="false"
              :clearable="false"
              disabled>
            </el-date-picker>
          </el-form-item>
          <!-- 买家信息 -->
          <p class="buyer-title-edit">{{ $t('orderEdit.buyerTitle') }}</p>
          <el-form-item :label="$t('orderDetail.customerName')" prop="name" class="buyer-infomation-details">
            <el-input v-model.trim="editForm.name" class="inputtotal-amount"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orderDetail.customerPhone')" prop="mobile" class="buyer-infomation-details">
            <el-input v-model.trim="editForm.mobile" class="inputtotal-amount"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orderDetail.customerEmail')" prop="email" class="buyer-infomation-details">
            <el-input v-model.trim="editForm.email" class="inputtotal-amount"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orderDetail.customerAdress')" prop="address" class="buyer-infomation-details address">
            <el-input v-model.trim="editForm.address" class="inputtotal-amount"></el-input>
          </el-form-item>
          <!-- 快递信息 -->
          <p class="buyer-title-edit">{{ $t('orderEdit.expressTitle') }}</p>
          <el-form-item :label="$t('orderDetail.logisticsMode')" prop="delivery_type" class="buyer-infomation-details">
            <el-select v-model.trim="editForm.delivery_type" @change="changeDate" :disabled="editForm.delivery_type === $t('remote.form.logisticsMode.option4')">
              <el-option v-for="item in logisticsModeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('remote.form.date')" class="express-date">
            <el-date-picker
              v-model.trim="editForm.delivery_time"
              type="date"
              :editable="false"
              :clearable="false"
              disabled
              :picker-options="pickerOptions">
              <!-- :disabled="dateStatus" -->
            </el-date-picker>
          </el-form-item>
          <!-- 备注信息 -->
          <p class="buyer-title-edit">{{ $t('orderEdit.description') }}</p>
          <el-form-item :label="$t('orderDetail.description')" class="count-number" prop="desc">
            <el-input :rows="5" type="textarea" v-model.trim="editForm.desc" :maxlength="500" @keyup.native="getCount" :placeholder="$t('remote.form.writeDescription')"></el-input>
            <span>{{count}}/500</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('orderManage.cancel' )}}</el-button>
        <el-button type="primary" :disabled="btnStatus" @click="onSubmit">{{ $t('orderManage.confirm' )}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import config from 'config'
import qs from 'qs'
import { adjustDate } from '../../common/js/util'
export default {
  data () {
    let checkExpressNo = (rule, val, cb) => {
      if (val && !/^[0-9A-Za-z]*$/.test(val)) {
        cb(this.$t('orderManage.deliveFormat'))
      } else {
        cb()
      }
    }
    let emailValid = (rul, val, cb) => {
      if(!/^[\w-]+[\w-.]*@[a-zA-Z\d-]+(\.[a-zA-Z\d-]+)*\.[a-zA-Z\d]{2,6}$/.test(val) && val !== '') {
        cb(this.$t('overseaForget.invalidEmail'))
      }else{
        cb()
      }
    }
    let validCustomerName = (rul, val, cb) => {
      if ((/[^\u4e00-\u9fa5_a-zA-Z 0-9()-]/g).test(val)) {
        cb(this.$t('remote.rules.otherValidMessage'))
      } else {
        cb()
      }
    }
    let validPhone = (rul, val, cb) => {
      if (/^\d{1,3}-\d{1,20}?$/.test(val) || val === '') {
        cb()
      } else {
        cb(this.$t('remote.rules.customerPhoneMessage'))
      }
    }
    let validRemark = (rul, val, cb) => {
      if ((/[-;&=<>%]/im).test(val)) {
        cb(this.$t('remote.rules.otherValidMessage'))
      } else {
        cb()
      }
    }
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      count: 0,
      mcntOrderId: '',
      payOrderId: '',
      linkId: '',
      tranStatus: '',
      tranStatusLang: '',
      payLink: '',
      stime: '',
      totalNum: '',
      deliveryStatus: '',
      deliveryStatusLang: '',
      payClosingDate: '',
      goods_info: [],
      customer_info: {
        mobile: '',
        name: '',
        email: '',
        address: ''
      },
      delivery_info: {
        express_name: '',
        express_no: '',
        delivery_time: '',
        delivery_type: ''
      },
      expressForm: {
        express_name: '',
        express_no: ''
      },
      show: false,
      dialogVisible: false,
      desc: '',
      order_id: '',
      dateStatus: false,
      // 编辑模块数据
      editForm: {
        goods_info: [],
        totalCurrency: '344',
        totalAmount: '',
        paymentDeadline: '',
        name: '',
        mobile: '',
        email: '',
        address: '',
        delivery_type: '',
        delivery_time: '',
        desc: ''
      },
      deliveryBtnStatus: false,
      btnStatus: false,
      currencyList: {
        // '156': 'CNY',
        '344': 'HKD'
      },
      currentList: [
        { 'name': 'HKD', 'value': '344' },
        // { 'name': 'CNY', 'value': '156' }
      ],
      logisticsModeList: [
        // {name: this.$t('remote.form.logisticsMode.option1'), value: '3'},
        {name: this.$t('remote.form.logisticsMode.option2'), value: '2'},
        {name: this.$t('remote.form.logisticsMode.option3'), value: '1'},
        // {name: this.$t('remote.form.logisticsMode.option4'), value: '0'}
      ],
      deliveryStatusList: {
        1: this.$t('orderManage.filter.notdelivered'),
        2: this.$t('orderManage.filter.delivered')
      },
      expressFormRules: {
        express_no: [
          { validator: checkExpressNo, trigger: 'blur' }
        ]
      },
      editFormRules: {
        name: [
          { validator: validCustomerName, trigger: 'blur' }
        ],
        mobile: [
          { validator: validPhone, trigger: 'blur' }
        ],
        email: [
          { validator: emailValid, trigger: 'blur' }
        ],
        address: [
          { validator: validCustomerName, trigger: 'blur' }
        ],
        desc: [
          { validator: validRemark, trigger: 'blur' }
        ]
      //   goods_name: [
      //     { validator: goodNameVlid, trigger: 'blur' }
      //   ],
      //   quantity: [
      //     { required: true, message: this.$t('remote.rules.quantityRules'), trigger: 'blur' },
      //     { validator: numberValidQuantity, trigger: 'blur' }
      //   ],
      //   unit_price: [
      //     { required: true, message: this.$t('remote.rules.unitPriceRules'), trigger: 'blur' },
      //     { validator: numberValidprice, trigger: 'blur' }
      //   ],
      //   total_currency: [
      //     {}
      //   ]
      }
    }
  },
  created () {
    this.getDetailsInfo()
  },
  methods: {
    getDetailsInfo () {
      let form = JSON.parse(this.$route.query.form)
      if (form) {
        this.mcntOrderId = form.order_id || ''
        this.payOrderId = form.syssn || ''
        this.linkId = form.link_id || ''
        this.tranStatus = form.order_status || ''
        this.tranStatusLang = form.order_status_lang || ''
        this.payLink = form.link_url || ''
        this.stime = form.order_time || ''
        this.totalNum = form.amount || ''
        this.deliveryStatusLang = form.delivery_status_lang || ''
        this.payClosingDate = form.pay_close_date || ''
      }
      this.getDetails()
    },
    getDetails () {
      axios.get(`${config.oHost}/remotepay/order/order_info`, {
        params: {
          order_id: this.mcntOrderId,
          format: 'cors'
        }
      }).then(res => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.goods_info = data.data.goods_info
          for (let i = 0; i < this.goods_info.length; i++) {
            if (this.goods_info[i].quantity && this.goods_info[i].unit_price) {
              let totalCurrency = (Number(this.goods_info[i].quantity) * Number(this.goods_info[i].unit_price) * 100 / 100).toFixed(2)
              this.$set(this.goods_info[i], 'total_currency', totalCurrency)
            }
          }
          this.customer_info = data.data.customer_info
          this.delivery_info = data.data.delivery_info
          this.deliveryStatus = data.data.delivery_info.status
          this.desc = data.data.desc
          if (this.delivery_info.delivery_type) {
            if (this.delivery_info.delivery_type === 1) {
              this.delivery_info.delivery_type = this.$t('remote.form.logisticsMode.option3')
            } else if (this.delivery_info.delivery_type === 2) {
              this.delivery_info.delivery_type = this.$t('remote.form.logisticsMode.option2')
            } else if (this.delivery_info.delivery_type === 3) {
              this.delivery_info.delivery_type = this.$t('remote.form.logisticsMode.option1')
            }
          }
          if (this.delivery_info.delivery_type === 0 || this.delivery_info.delivery_type === null) {
            this.delivery_info.delivery_type = this.$t('remote.form.logisticsMode.option4')
          }
        }
      })
    },
    cancelDelivery () {
      this.$refs['expressForm'].resetFields()
      this.show = false
    },
    delivery () {
      this.$refs['expressForm'].validate((valid) => {
        if (valid) {
          let params = {
            order_id: this.mcntOrderId,
            express_name: this.expressForm.express_name,
            express_no: this.expressForm.express_no,
            format: 'cors'
          }
          this.deliveryBtnStatus = true
          axios.post(`${config.oHost}/remotepay/order/order_deliver_status`, qs.stringify(params)).then(res => {
            let data = res.data
            if (data.respcd === config.code.OK) {
              this.show = false
              this.getDetails()
              this.deliveryBtnStatus = false
            } else {
              this.deliveryBtnStatus = false
              this.$message.error(data.resperr)
            }
          })
        }
      })
    },
    openEdit () {
      this.dialogVisible = true
      this.editForm.goods_info = this.goods_info
      this.editForm.totalAmount = this.totalNum.substr(3)
      this.editForm.paymentDeadline = this.payClosingDate
      this.editForm.name = this.customer_info.name
      this.editForm.mobile = this.customer_info.mobile
      this.editForm.email = this.customer_info.email
      this.editForm.address = this.customer_info.address
      this.editForm.delivery_type = this.delivery_info.delivery_type
      this.editForm.delivery_time = this.delivery_info.delivery_time
      this.editForm.desc = this.desc
    },
    changeDate () {
      if (this.editForm.delivery_type === '0' || this.editForm.delivery_type === '1') {
        this.editForm.delivery_time = ''
        this.dateStatus = true
      } else {
        this.dateStatus = false
      }
    },
    getCount () {
      this.count = this.editForm.desc.length
    },
    onSubmit () {
      let logisticsType = this.editForm.delivery_type
      if (logisticsType === this.$t('remote.form.logisticsMode.option3') || logisticsType === '1') {
        logisticsType = 1
      } else if (logisticsType === this.$t('remote.form.logisticsMode.option2') || logisticsType === '2') {
        logisticsType = 2
      } else if (logisticsType === this.$t('remote.form.logisticsMode.option1') || logisticsType === '3') {
        logisticsType = 3
      } else if (logisticsType === this.$t('remote.form.logisticsMode.option4') || logisticsType === '0') {
        logisticsType = 0
      } else {
        logisticsType = ''
      }
      let customerInfo = {
        mobile: this.editForm.mobile,
        name: this.editForm.name,
        email: this.editForm.email,
        address: this.editForm.address
      }
      let linkorderInfo = {
        goods_info: this.editForm.goods_info,
        total_amount: this.editForm.totalAmount,
        currency: this.editForm.totalCurrency,
        pay_close_date: this.editForm.paymentDeadline,
        logistics_type: logisticsType,
        estimate_delivery_date: this.editForm.delivery_time ? adjustDate(this.editForm.delivery_time) : '',
        remark: this.editForm.desc,
      }
      let params = {
        order_id: this.mcntOrderId,
        link_info: JSON.stringify(linkorderInfo),
        customer_info: JSON.stringify(customerInfo),
        format: 'cors'
      }
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.btnStatus = true
          axios.post(`${config.oHost}/remotepay/order/order_info`, qs.stringify(params)).then(res => {
            let data = res.data
            if (data.respcd === config.code.OK) {
              this.$router.push({path: '/main/orderComponent'})
              this.btnStatus = false
            } else {
               this.btnStatus = false
              this.$message.error(data.resperr)
            }
          })
        }
      })
    },
  }
}
</script>

<style lang="scss">
  .order-detail {
    .banner_wrapper {
      .el-breadcrumb__item__inner {
         color: #262424 !important;
      }
    }
    .panel {
      .panel-header {
        height: 52px;
        .details {
          background-color: #FEFDFB;
          height: 52px;
          line-height: 52px;
          .panel-header__desc {
            float: left;
          }
          .panel-header-btn {
            margin-top: 6px;
            float: right;
            width: 164px;
            height: 40px;
            line-height: 40px;
            box-sizing: border-box;
          }
          .btn1 {
            margin-right: 20px;
          }
          .btn2 {
            margin-right: 15px;
          }
        }
      }
      .panel-body {
        padding: 28px 29px 0 30px;
        .mcht-information {
          .mcht {
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            padding-bottom: 20px;
            p:nth-child(1) {
              color: #8A8C92;
              width: 144px;
              float: left;
              margin-right: 35px;
            }
            p:nth-child(2) {
              color: #000000;
              float: left;
            }
          }
          .expected-date {
            height: 32px;
            font-size: 16px;
            line-height: 16px;
            border-bottom: 1px solid #E8E7E6;
          }
        }
        .product-information {
          .product-title {
            margin-top: 30px;
            margin-bottom: 13px;
          }
          .el-table {
            .el-table__body-wrapper {
              tbody {
                .el-table__row {
                  td {
                    border-bottom: none;
                  }
                }
              }
            }
          }
          .product {
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            margin-top: 20px;
            p:nth-child(1) {
              color: #8A8C92;
              width: 144px;
              float: left;
              margin-right: 35px;
            }
            p:nth-child(2) {
              color: #000000;
              float: left;
            }
          }
          .delivery-status {
            padding-bottom: 30px;
            border-bottom: 1px solid #E8E7E6;
          }
        }
        .buyer-information {
          .buyer-title {
            margin-top: 30px;
            margin-bottom: 20px;
            font-size: 18px;
            height: 16px;
            line-height: 16px;
            font-weight: 500;
          }
          .buyer {
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            padding-bottom: 20px;
            p:nth-child(1) {
              color: #8A8C92;
              width: 155px;
              float: left;
              margin-right: 24px;
            }
            p:nth-child(2) {
              color: #000000;
              float: left;
            }
          }
          .buyer:nth-last-child(1) {
            padding-bottom: 30px;
            border-bottom: 1px solid #E8E7E6;
          }
        }
        .express-information {
          .express-title {
            margin-top: 30px;
            margin-bottom: 20px;
            font-size: 18px;
            height: 16px;
            line-height: 16px;
            font-weight: 500;
          }
          .express {
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            padding-bottom: 12px;
            p:nth-child(1) {
              color: #8A8C92;
              width: 170px;
              float: left;
              margin-right: 35px;
            }
            p:nth-child(2) {
              color: #000000;
              float: left;
            }
          }
          .express:nth-last-child(1) {
            height: 32px;
            padding-bottom: 22px;
            border-bottom: 1px solid #E8E7E6;
            // p:nth-child(2) {
            //   height: 32px;
            //   line-height: 32px;
            // }
          }
        }
        .remaks {
          .remaks-title {
            margin-top: 30px;
            margin-bottom: 20px;
            font-size: 18px;
            height: 16px;
            line-height: 16px;
            font-weight: 500;
          }
          .remark-content {
            font-size: 16px;
            line-height: 16px;
            padding-bottom: 30px;
          }
        }
      }
    }
    .fe_dialog {
      .el-dialog {
        width: 500px;
        height: 382px;
        padding-left: 30px;
        padding-right: 30px;
        box-sizing: border-box;
        .el-dialog__header {
          position: relative;
          padding: 0;
          padding-top: 30px;
          .dialogTitle {
            text-align: center;
          }
          .el-dialog__headerbtn {
            position: absolute;
            top: 21px;
            right: 0px;
          }
        }
        .el-dialog__body {
          padding: 0;
          margin-top: 26px;
          .dialogContent {
            p {
              color: #282B2D;
              font-size: 16px;
              line-height: 24px;
            }
            .el-form {
              .el-form-item {
                padding-bottom: 30px;
                .el-form-item__label {
                  height: 32px;
                }
                .el-form-item__content {
                  .el-input {
                    height: 32px;
                    .el-input__inner {
                      height: 32px;
                    }
                  }
                }
              }
              .el-form-item:nth-child(1) {
                margin-top: 25px;
              }
              .el-form-item:nth-child(2) {
                border-bottom: 1px solid #E8E7E6;
              }
            }
          }
        }
        .el-dialog__footer {
          padding: 0;
          margin-top: 20px;
          .dialog-footer {
            button {
              width: 100px;
              height: 40px;
              span {
                font-size: 15px;
              }
            }
            button:nth-child(1) {
              border: 1px solid #FE9B20;
              color: #FE9B20;
            }
            button:nth-child(2) {
              border: none;
              background-color: #7ED321;
              border-radius: 3px;
              color: #FBFBFB;
              margin-left: 20px;
            }
          }
        }
      }
    }
    .edit-information {
      .el-dialog {
        width: 900px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 20px;
        box-sizing: border-box;
        .el-dialog__header {
          position: relative;
          padding: 0;
          padding-top: 30px;
          .dialogTitle {
            text-align: center;
            p {
              font-size: 20px;
              height: 20px;
              line-height: 20px;
              font-weight: 500;
              color: #282B2D;
            }
          }
          .el-dialog__headerbtn {
            position: absolute;
            top: 21px;
            right: 21px;
          }
        }
        .el-dialog__body {
          padding: 0;
          margin-top: 26px;
          .dialogContent {
            .el-form {
              .tableDatas {
                &::before {
                  height: 0;
                }
                .el-table__header-wrapper {
                  thead {
                    tr {
                      th {
                        background-color: #FFFFFF;
                      }
                    }
                  }
                }
                .el-table__body-wrapper {
                  .el-table__row {
                    margin-bottom: 20px;
                    height: 56px;
                    td {
                      border-bottom: none;
                    }
                  }
                }
              }
              .el-form-item {
                margin: 20px 0;
                .total-amount {
                  width: 80px;
                  .el-input {
                    width: 80px;
                  } 
                }
                .inputtotal-amount {
                  width: 179px;
                  margin-left: 5px;
                }
              }
              .sing-validte {
                margin: 0 !important;
                display: inline-block;
              }
              .fe_payment-date {
                margin-bottom: 0;
                padding-bottom: 20px;
                border-bottom: 1px solid #E8E7E6;
              }
              .buyer-title-edit {
                height: 16px;
                font-size: 18px;
                font-weight: 500px;
                line-height: 16px;
                color: #000000;
                margin-top: 30px;
              }
              .buyer-infomation-details {
                margin: 20px 0;
                padding: 0;
                border-bottom: none;
              }
              .address {
                margin-bottom: 0;
                padding-bottom: 30px;
                border-bottom: 1px solid #E8E7E6;
                .el-form-item__content {
                  width: 658px;
                  .el-input {
                    width: 658px;
                  }
                }
              }
              .express-date {
                margin-bottom: 0;
                padding-bottom: 30px;
                border-bottom: 1px solid #E8E7E6;
              }
              .count-number {
                margin-bottom: 0;
                padding-bottom: 30px;
                border-bottom: 1px solid #E8E7E6;
                .el-form-item__content {
                  position: relative;
                  span {
                    position: absolute;
                    right: 10px;
                    bottom: 0;
                    color: #909297;
                  }
                }
              }
            }
          }
        }
        .el-dialog__footer {
          padding: 0;
          margin-top: 20px;
          .dialog-footer {
            button {
              width: 100px;
              height: 40px;
              span {
                font-size: 15px;
              }
            }
            button:nth-child(1) {
              border: 1px solid #FE9B20;
              color: #FE9B20;
            }
            button:nth-child(2) {
              border: none;
              background-color: #7ED321;
              border-radius: 3px;
              color: #FBFBFB;
              margin-left: 20px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// orderDetail.vue?f70086e4